import styled from "styled-components";
// import { Props } from "../../../types/types";

// No overload matches this call? Add TS type to Props file. e.g.

// type SectionProps = {
//   bg: any;
//   bgImage: any;
//   height: any;
// };

// export const Section = styled.section<SectionProps>`
//   background-color: ${(props) => props.bg || "#fff"};
//   height: ${(props) => props.height || null};
//   background-image: url(${(props) => props.bgImage || null});
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: center center;
//   position: relative;
//   overflow: hidden;
//   box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.5);
//   z-index: 1;
//   padding: 2rem 0;
// `;

type Props = {
  margin?: number | string;
  marginTop?: number;
  marginBottom?: number;
}

export const Container = styled.div<Props>`
  width: 1400px;
  max-width: 100%;
  padding: 0 20px;
  margin: ${({margin}) => margin ? `${margin}px auto` : '0 auto'};
  margin-top: ${({marginTop}) => marginTop ? `${marginTop}px` : ''};
  // margin-bottom: ${({marginBottom}) => marginBottom ? `${marginBottom}px` : ''};
  // background-color: ${(props) => props.theme.colors.primaryLight};
`;
